// extracted by mini-css-extract-plugin
export default {"viewMore":"index_viewMore_CbMfO","viewMoreBorder":"index_viewMoreBorder_vLSje","viewMoreText":"index_viewMoreText_4qFrQ"};